export function handleFilterDateRange(time) {
  let starttime = ''
  let endtime = ''
  if (time) {
    if (time[0] && Date.parse(time[0])) {
      starttime = getDate(time[0]) + ' 00:00:00'
    } else {
      if (typeof time[0] === 'undefined') {
        starttime = ''
      }
    }
    if (time[1] && Date.parse(time[1])) {
      endtime = getDate(time[1]) + ' 23:59:59'
    } else {
      if (typeof time[1] === 'undefined') {
        endtime = ''
      }
    }
  }
  if (starttime !== '' && endtime !== '') {
    return ['between', starttime, endtime]
  } else if (starttime !== '') {
    return ['>=', starttime]
  } else if (endtime !== '') {
    return ['<=', endtime]
  } else {
    return undefined
  }
}
export function getDate(time) {
  if(!time){
    return ''
  }
  var date = new Date(time)
  var y = date.getFullYear()
  var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
  return y + '-' + m + '-' + d
}
//数字格式化
export function numFormatter(str){
  if(str) {
    str = str.replace(/\s+/g,"");
    if(!(/^\d+$/.test(str))) {
      str = '0'
    }
  }
  return str
}
/**
 *
 * 日期格式化
 * @param {*} fmt 例：h:i:s <10时候不补0
 * @param {*} date 例：2021-5-20 15:42:19
 * @param {*} isTimestamp 是否是时间戳
 * @returns
 */
export function formatDate(fmt = 'yyyy-MM-dd hh:mm:ss', date = '', isTimestamp = false) {
  if (date) {
    date = new Date(isTimestamp ? date : date.replace(/-/g, '/'))
  } else {
    date = new Date()
  }
  let ret
  const opt = {
    'y+': date.getFullYear().toString(), // 年
    'M+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'h+': date.getHours().toString(), // 时
    'm+': date.getMinutes().toString(), // 分
    's+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
    }
  }
  return fmt
}



// WEBPACK FOOTER //
// ./src/utils/date.js